/**
 * Bucket configuration for the Open Tickets Ageing Report (V2 API).
 *
 * Ageing buckets become the report's columns; ASO assignment buckets never do,
 * they only restrict the rows of both tables.
 */

export const AGE_BUCKETS = ['0-2', '3-5', '6-15', '>15'];
export const ASO_ASSIGNMENT_BUCKETS = ['0', '1-3', '4-8', '>8'];

/** Normalise a bucket selection. Empty / unknown means every bucket. */
export function toBucketList(value, allBuckets) {
  let items = value;
  if (typeof items === 'string') {
    items = items.length ? items.split(',') : [];
  }
  if (!Array.isArray(items)) {
    items = [];
  }
  const picked = items.map(item => String(item).trim());
  const selected = allBuckets.filter(bucket => picked.indexOf(bucket) !== -1);
  return selected.length ? selected : allBuckets.slice();
}

export function selectedAgeBuckets(ageing) {
  return toBucketList(ageing, AGE_BUCKETS);
}

/** `headerLabel` overrides the group header when it differs from the data key. */
export function agingColumns(displayName, ageing, headerLabel) {
  const columns = [
    { data: displayName, title: headerLabel || displayName, width: '220px' },
    { data: 'Total', title: 'Total' }
  ];
  selectedAgeBuckets(ageing).forEach(bucket => {
    columns.push({ data: bucket, title: bucket });
  });
  return columns;
}

export function numericColumnTargets(ageing) {
  const targets = [];
  const count = selectedAgeBuckets(ageing).length + 1;
  for (let i = 1; i <= count; i++) {
    targets.push(i);
  }
  return targets;
}

/** Column 0 is the group, 1 is "Total" (no bucket), 2+ are the selected buckets. */
export function ageBucketForColumn(ageing, colIndex) {
  if (colIndex <= 1) {
    return null;
  }
  return selectedAgeBuckets(ageing)[colIndex - 2] || null;
}
